import preview from '@/assets/solution/photo-storytelling/preview.png';

export default {
  solutionName: 'Photo Storytelling',
  videoUrl: 'https://www.youtube.com/embed/WhWc3b3KhnY',
  imageUrl: preview,
  toolUrl: '/photo-storytelling',
};
